export const EXAM_TYPES = ['Unit Test', 'Half-Yearly', 'Annual', 'Practice'];
export const CLASSES = ['Nursery', 'LKG', 'UKG', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'];
export const SESSIONS = ['2024-2025', '2025-2026', '2026-2027', '2027-2028'];
export const SUBJECT_PRESETS = [
  'English', 'Hindi', 'Mathematics', 'Science', 'Social Science', 'EVS', 'Sanskrit',
  'Computer Science', 'Physics', 'Chemistry', 'Biology', 'History', 'Geography', 'Civics', 'Economics'
];

export const TYPE_LABEL = {
  MCQ: 'Multiple Choice', FillBlanks: 'Fill in the Blanks', TrueFalse: 'True / False',
  Short: 'Short Answer', Long: 'Long Answer', Case: 'Case-Based'
};

export const SECTION_TITLES = {
  A: 'OBJECTIVE TYPE', B: 'SHORT ANSWER TYPE', C: 'LONG ANSWER TYPE', D: 'CASE-BASED / DESCRIPTIVE'
};

export const GENERAL_INSTRUCTIONS = [
  'All questions are compulsory unless an internal choice is given.',
  'Read each question carefully before answering.',
  'The marks for each question are shown against it in square brackets on the right.',
  'Write neat and legible answers. Rough work, if any, must be done on the answer sheet.',
  'Do not write anything on the question paper other than your roll number.'
];

// Default blueprint: rows are what the AI is asked to generate for each section.
export const defaultBlueprint = () => ([
  { name: 'A', enabled: true, rows: [
    { type: 'MCQ', count: 10, marks: 1 },
    { type: 'FillBlanks', count: 5, marks: 1 },
    { type: 'TrueFalse', count: 5, marks: 1 }
  ], extra: 0 },
  { name: 'B', enabled: true, rows: [{ type: 'Short', count: 5, marks: 2 }], extra: 0 },
  { name: 'C', enabled: true, rows: [{ type: 'Long', count: 4, marks: 5 }], extra: 1 },
  { name: 'D', enabled: false, rows: [{ type: 'Case', count: 2, marks: 5 }], extra: 0 }
]);

export const blueprintTotal = (bp) =>
  bp.filter((s) => s.enabled).reduce((t, s) => t + s.rows.reduce((a, r) => a + (Number(r.count) || 0) * (Number(r.marks) || 0), 0), 0);

// Convert wizard blueprint to API payload. "extra" = internal-choice extra questions per row.
export const blueprintToRequest = (bp) =>
  bp.filter((s) => s.enabled).map((s) => ({
    name: s.name,
    title: SECTION_TITLES[s.name],
    attemptAny: s.extra > 0 ? s.rows.reduce((a, r) => a + (Number(r.count) || 0), 0) : 0,
    requests: s.rows.filter((r) => Number(r.count) > 0).map((r) => ({
      type: r.type, marks: Number(r.marks), count: Number(r.count) + (s.extra > 0 ? Number(s.extra) : 0)
    }))
  }));

// Marks a student can actually score in a section (honours "attempt any N").
export const sectionMarks = (section) => {
  const qs = section.questions || [];
  if (!qs.length) return 0;
  const total = qs.reduce((a, q) => a + (Number(q.marks) || 0), 0);
  const n = Number(section.attemptAny) || 0;
  if (n > 0 && n < qs.length) return Math.round(((total / qs.length) * n) * 100) / 100;
  return total;
};

export const paperMarks = (paper) =>
  Math.round((paper?.sections || []).reduce((a, s) => a + sectionMarks(s), 0) * 100) / 100;

export const renumber = (paper) => {
  let n = 0;
  return { ...paper, sections: paper.sections.map((s) => ({ ...s, questions: s.questions.map((q) => ({ ...q, qId: q.qId || `Q${++n}` })) })) };
};

export const SHEET_FONT = "'Noto Serif Devanagari','Noto Serif','Mangal','Nirmala UI','Kohinoor Devanagari','Times New Roman',serif";
